import { useCallback } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { requestPromptDraft } from 'src/components/ai/chat/chat-state';
import { getBackToAIRoute } from 'src/editor/toolbars/right-panel/BackToAIButton';
import { useGlobalDrawer } from 'src/layouts/GlobalRightDrawer';

/**
 * Puts a prompt in the chat input from inside the playbooks drawer, for the
 * user to finish and send. The chat pane is hidden behind this drawer view,
 * so the route goes back to the page's AI view first and the draft is queued
 * for the pane to pick up as it comes into view. The thread is left as it
 * is: a prompt from the drawer belongs with the document the drawer is on.
 */
export function useDraftPromptInChat(): (prompt: string) => void {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { openDrawer } = useGlobalDrawer();

  return useCallback(
    (prompt: string) => {
      const backToAiRoute = getBackToAIRoute(pathname);
      if (backToAiRoute) navigate(backToAiRoute, { replace: true });
      openDrawer();
      requestPromptDraft(prompt);
    },
    [navigate, openDrawer, pathname]
  );
}
